import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import { Button, useModalHandle } from '@spotahome/ui-library';

import ListingTag from './ListingTag';
import ListingTagModal from './ListingTagModal';

import './ListingTagContainer.scss';

const ListingTagContainer = ({ tagList = [], hasBackground = false }) => {
  const { isModalOpen, handleModalOpen, handleModalClose } = useModalHandle();

  const handleOpenModal = () => {
    handleModalOpen();
  };

  const handleCloseModal = () => {
    handleModalClose();
  };

  const allTags = tagList
    .filter(tag => !tag.hideInExperiment && tag.icon)
    .sort((a, b) => !!b.value - !!a.value || a.order - b.order)
    .map(tag => (
      <ListingTag
        key={tag.name}
        {...tag}
        hasBackground={hasBackground}
        isNotIncluded={!tag.value}
      />
    ));

  return (
    <>
      <ListingTagModal isOpen={isModalOpen} onRequestClose={handleCloseModal}>
        {allTags}
      </ListingTagModal>
      <div className="listing-tag-container">{allTags.slice(0, 8)}</div>
      {allTags.length > 8 && (
        <Button
          className="listing-tag-container__show-features-button listing-tag-container__show-features-button--experiment"
          color="link"
          onClick={handleOpenModal}
          dataTest="showRemainingFeaturesButton"
        >
          {trans('search.listing.show-all-features', {
            numberOfFeatures: allTags.length
          })}
        </Button>
      )}
    </>
  );
};

ListingTagContainer.propTypes = {
  tagList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      icon: PropTypes.string,
      description: PropTypes.string,
      descriptionClassName: PropTypes.string,
      order: PropTypes.number,
      hideInExperiment: PropTypes.bool
    })
  ),
  hasBackground: PropTypes.bool
};

export default ListingTagContainer;
